import { Card, CardContent } from "@/components/ui/Card";
import { Calendar, Phone, ChevronRight } from "lucide-react";

export default function HelpSection() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Walkthrough Card */}
      <Card className="py-0 bg-[#161a1e] border border-zinc-800 hover:border-brand-orange-500/60 transition-all rounded-xl">
        <CardContent className="p-4 sm:p-5">
          <a
            href="https://calendar.app.google/bQYWC7eRYu99z5p18"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between gap-3 group"
          >
            <div className="flex items-center gap-3.5">
              <div className="w-10 h-10 rounded-full bg-[#1c1917] border border-brand-orange-500/40 flex items-center justify-center shrink-0 text-brand-orange-500">
                <Calendar className="w-5 h-5" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm group-hover:text-brand-orange-400 transition-colors">
                  Book a 10-minute walkthrough
                </p>
                <p className="text-xs text-gray-400 mt-0.5">
                  See how it works and get your questions answered.
                </p>
              </div>
            </div>
            <ChevronRight className="w-5 h-5 text-gray-500 group-hover:text-white transition-colors shrink-0" />
          </a>
        </CardContent>
      </Card>

      {/* Specialist Contact Card */}
      <Card className="py-0 bg-[#161a1e] border border-zinc-800 hover:border-brand-orange-500/60 transition-all rounded-xl">
        <CardContent className="p-4 sm:p-5">
          <div className="flex items-center justify-between gap-3 group">
            <div className="flex items-center gap-3.5">
              <div className="w-10 h-10 rounded-full bg-[#1c1917] border border-brand-orange-500/40 flex items-center justify-center shrink-0 text-brand-orange-500">
                <Phone className="w-5 h-5" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">
                  Speak to a SolarCloud Specialist
                </p>
                <p className="text-xs text-gray-400 mt-0.5">
                  Our team can help you choose the right size for your goals.
                </p>
                <a
                  href="tel:0292584000"
                  className="text-blue-400 hover:text-blue-300 font-bold text-xs sm:text-sm mt-1 inline-block"
                >
                  02 9258 4000
                </a>
              </div>
            </div>
            <a href="tel:0292584000" className="text-gray-500 hover:text-white transition-colors">
              <ChevronRight className="w-5 h-5" />
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
